import React, { useEffect, useRef,useState } from "react";
import * as am5 from "@amcharts/amcharts5";
import * as am5map from "@amcharts/amcharts5/map";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";
import am5geodata_worldLow from "@amcharts/amcharts5-geodata/worldLow";

const AllCountryCharts = ({ dashboardData = {} }) => {
  const chartRef = useRef(null);

  useEffect(() => {
    if (!dashboardData) return;

    const root = am5.Root.new(chartRef.current);
    root.setThemes([am5themes_Animated.new(root)]);
    root._logo?.dispose?.();

    const chart = root.container.children.push(
      am5map.MapChart.new(root, {
        panX: "none",
        panY: "none",
        projection: am5map.geoMercator(),
        maxZoomLevel: 1,
      })
    );

    const polygonSeries = chart.series.push(
      am5map.MapPolygonSeries.new(root, {
        geoJSON: am5geodata_worldLow,
        exclude: ["AQ"],
      })
    );

    const formattedData = dashboardData.map((item) => {
      const buyer = parseInt(item.buyer_count || 0);
      const supplier = parseInt(item.supplier_count || 0);
      const logistic = parseInt(item.logistic_partner_count || 0);
      const total = buyer + supplier + logistic;

      let color = 0xeef1f3;
      if (total > 0 && total < 5) color = 0xfab72d;
      else if (total >= 5 && total < 10) color = 0x4caf46;
      else if (total >= 10) color = 0xdf0024;
    
      return {
        id: item.country_code,
        name: item.country_name,
        buyer,
        supplier,
        logistic,
        value: total,
        fill: am5.color(color),
      };
    });

    polygonSeries.mapPolygons.template.setAll({
      tooltipHTML:
        "<strong>{name}</strong><br>Buyers: {buyer}<br>Suppliers: {supplier}<br>Logistics: {logistic}",
      interactive: true,
      cursorOverStyle: "pointer",
      stroke: am5.color(0xffffff),
      strokeWidth: 0.5,
    });

    polygonSeries.mapPolygons.template.adapters.add("fill", function (_, target) {
      const id = target.dataItem?.dataContext?.id;
      const match = formattedData.find((d) => d.id === id);
      return match ? match.fill : am5.color(0xeef1f3);
    });

    polygonSeries.mapPolygons.template.adapters.add("tooltipHTML", function (_, target) {
      const id = target.dataItem?.dataContext?.id;
      const match = formattedData.find((d) => d.id === id);

      let dataItem = target.dataItem;

      return match ? "<strong>" + match.name + "</strong > <br>Buyers: " + match.buyer + "<br>Suppliers: " + match.supplier + "<br>Logistics: " + match.logistic : "<strong>" + dataItem.dataContext.name + "</strong > <br>Buyers: " + 0 + "<br>Suppliers: " + 0 + "<br>Logistics: " + 0;
    });

    polygonSeries.data.setAll(formattedData);

    return () => {
      root.dispose();
    };
  }, [dashboardData]);

  return (
    <div>
      <div className="head underline">
        <h3>World wide Buyers/Suppliers/Logistic Partners</h3>
      </div>
      <div
        ref={chartRef}
        style={{ width: "100%", height: "500px" }}
      ></div>
    </div>
  );
};

export default AllCountryCharts;
